export const anilibria_url = 'https://api.anilibria.tv/v3.0';
export const shikimori_url  = 'https://shikimori.me/api';
export const litelibria_poster_url = 'https://static.litelibria.com/posters/ru/';